import { render, staticRenderFns } from "./force_logout_email.vue?vue&type=template&id=46fa63c7"
import script from "./force_logout_email.vue?vue&type=script&lang=js"
export * from "./force_logout_email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fa63c7')) {
      api.createRecord('46fa63c7', component.options)
    } else {
      api.reload('46fa63c7', component.options)
    }
    module.hot.accept("./force_logout_email.vue?vue&type=template&id=46fa63c7", function () {
      api.rerender('46fa63c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/force_logout_email.vue"
export default component.exports